import { Formik, Form, Field } from 'formik'
import { useMutation } from '@apollo/client'
import { FC } from 'react'

import { Input } from 'components/new-ui'
import { USER_BASE_DATA } from 'gql/user/queries'
import { SET_USER_DATE_OF_BIRTH } from 'gql/user/mutations'

const DateOfBirthForm: FC<{ onCompleted?: () => void }> = ({ onCompleted }) => {
  const [setUserDateOfBirth, { loading }] = useMutation(SET_USER_DATE_OF_BIRTH, {
    refetchQueries: [USER_BASE_DATA],
    onCompleted: () => {
      onCompleted?.()
    },
  })

  return (
    <Formik
      initialValues={{ dateOfBirth: '' }}
      onSubmit={(values) => {
        if (!values.dateOfBirth) return

        const date = new Date(values.dateOfBirth)

        setUserDateOfBirth({
          variables: {
            input: { day: date.getDate(), month: date.getMonth() + 1, year: date.getFullYear() },
          },
        })
      }}
    >
      <Form className="space-y-4">
        <Field
          placeholder="Your birthday"
          className="uppercase"
          name="dateOfBirth"
          type="date"
          as={Input}
        />

        <button className="btn btn-primary w-full" type="submit" disabled={loading}>
          {loading ? 'submitting' : 'continue'}
        </button>
      </Form>
    </Formik>
  )
}

export default DateOfBirthForm
